<template>
  <admin-layout>
    <template slot="content">
      <v-layout column>
        <v-card class="pa-5">
          <span class="title -tongue ml-5 d-block">
            Para qual CPF ou CNPJ será alterado os dados do requerente?
          </span>
          <v-form ref="form" v-model="valid">
            <v-form ref="cpfCnpjForm" v-model="cpfCnpjFormValid">
              <v-layout row class="mb-2">
                <v-flex xs4>
                  <v-text-field
                      label="CPF ou CNPJ"
                      v-model="cpfCnpj"
                      :mask="cpfCnpj.length >= 12 ? cnpjMask : cpfMask"
                      prepend-icon="mdi-magnify"
                      :rules="[validationRules.cpfCnpj]"
                      @keydown.enter="fetchCpfCnpj"
                      required
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs2>
                  <v-btn
                      fab
                      small
                      color="primary"
                      :disabled="!cpfCnpjFormValid"
                      @click="fetchCpfCnpj()">
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-form>

            <div v-if="showEntity">
              <v-layout>
                <v-flex xs6>
                  <v-text-field
                      label="Email"
                      v-model="entity.email"
                      prepend-icon="mdi-email"
                      :rules="[validationRules.required, validationRules.email]"
                      required
                  />
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex xs6>
                  <v-text-field
                      label="Nome Completo / Razão Social"
                      v-model="entity.name"
                      :rules="[validationRules.required]"
                      prepend-icon="mdi-account"
                      required/>
                </v-flex>

              </v-layout>

              <v-layout class="mb-4" v-if="cpfCnpj.length == 14">
                <v-flex xs6 sm6 d-flex>
                  <v-select
                      :items="enquadramentos"
                      v-model="entity.enquadramento"
                      :rules="[validationRules.required]"
                      prepend-icon="mdi-domain"
                      label="Enquadramento"
                  ></v-select>
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex xs6>
                  <header class="headline">
                    <h5 class="title">
                      <v-icon class="mr-2">mdi-map-marker</v-icon>
                      Qual o endereço?
                    </h5>
                  </header>

                  <v-card class="mb-5">
                    <v-container grid-list-lg>
                      <v-layout row>
                        <v-flex xs4>
                          <v-text-field
                              v-model="entityAddress.zip_code"
                              label="CEP"
                              mask="##.###-###"
                              :rules="[validationRules.required]"
                          />
                        </v-flex>
                        <v-flex>
                          <v-btn
                              fab
                              small
                              primary
                              color="primary"
                              @click="fetchZipCodeForEntityAddress()"
                          >
                            <v-icon>mdi-magnify</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                      <v-layout row>
                        <v-flex xs8>
                          <v-text-field
                              v-model="entityAddress.street"
                              label="Logradouro"
                              :rules="[validationRules.required]"
                          />
                        </v-flex>

                        <v-flex xs4>
                          <v-text-field
                              v-model="entityAddress.number"
                              label="Número"
                              :rules="[validationRules.required]"
                          />
                        </v-flex>
                      </v-layout>
                      <v-layout row>
                        <v-flex xs6>
                          <v-text-field
                              v-model="entityAddress.complement"
                              label="Complemento"

                          />
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                              v-model="entityAddress.neighborhood"
                              label="Bairro"
                              :rules="[validationRules.required]"
                          />
                        </v-flex>
                      </v-layout>
                      <v-layout row>
                        <v-flex xs4>
                          <v-autocomplete
                              :items="federalUnits"
                              v-model="entityAddress.federal_unit"
                              @change="fetchCities(entityAddress.federal_unit)"
                              :rules="[validationRules.required]"
                              label="Selecione um estado"
                              no-data-text="Nenhum resultado encontrado"
                              item-text="name"
                              item-value="id"
                              return-object
                              single-line/>
                        </v-flex>
                        <v-flex xs8>
                          <v-autocomplete
                              v-model="entityAddress.city"
                              :items="otherCities"
                              :rules="[validationRules.required]"
                              label="Selecione uma cidade"
                              no-data-text="Nenhum resultado encontrado"
                              item-text="name"
                              item-value="id"
                              return-object
                              single-line/>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card>
                </v-flex>
              </v-layout>
            </div>
          </v-form>

          <v-card-actions v-if="showEntity">
            <v-btn flat :to="{name: 'ApplicationsAndSubpoenasForAdmin'}">Cancelar</v-btn>
            <v-btn :disabled="!valid" color="success" @click="updateEntity">Salvar</v-btn>
          </v-card-actions>
        </v-card>
      </v-layout>
    </template>
  </admin-layout>
</template>

<script>
import AdminLayout from '@/layouts/AdminLayout';
import EntityService from '@/services/EntityService';
import FederalUnitService from '@/services/FederalUnitService';
import AddressService from '@/services/AddressService';
import { find } from 'lodash';
import validationRules from '@/mixins/validation-rules';

export default {
  name: 'Update',
  mixins: [validationRules],
  components: {
    AdminLayout,
  },
  async beforeCreate() {
    this.federalUnits = await FederalUnitService.fetchFederalUnits();
  },
  data() {
    return {
      valid: false,
      cpfCnpjFormValid: false,
      cpfCnpj: '',
      cpfMask: '###.###.###-###',
      cnpjMask: '##.###.###/####-##',
      validationRules,
      federalUnits: [],
      cities: [],
      otherCities: [],
      showEntity: false,

      entity: { id: '', enquadramento: null, email: '' },
      entityAddress: { zip_code: '' },

      enquadramentos: [
        'Não possui', 'ME', 'EPP', 'MEI',
      ],
    };
  },
  methods: {
    async fetchZipCodeForEntityAddress() {
      try {
        this.$store.dispatch('setLoadingDialog', true);

        const address = await AddressService.fetchZipCode(this.entityAddress.zip_code)
        const federalUnitForEntityAddress = find(this.federalUnits, { acronym: address.acronym })
        this.otherCities = await FederalUnitService.fetchCities(federalUnitForEntityAddress.id)
        const cityForEntityAddress = find(this.otherCities, { name: address.city })

        this.entityAddress = {
          ...address,
          federal_unit: federalUnitForEntityAddress,
          city: cityForEntityAddress,
          latitude: this.latitude,
          longitude: this.longitude
        }
      } catch (e) {
        this.showSwalError('Erro ao consultar CEP da Pessoa Física ou Jurídica')
      }
      this.$store.dispatch('setLoadingDialog', false);
    },
    async fetchCpfCnpj() {
      this.$store.dispatch('setLoadingDialog', true);
      const vm = this;

      EntityService
        .fetch(this.cpfCnpj)
        .then(async ({ data }) => {
          const cityForEntityAddress = await vm.findCityForEntityAddress(data);

          vm.entity = {
            id: data.id,
            name: data.name,
            cpfCnpj: this.cpfCnpj,
            email: data.email,
            enquadramento: data.enquadramento
          };
          vm.entityAddress = {
            ...data.address,
            city: cityForEntityAddress
          };

          vm.isApplicationAddressDifferent = data.address.federal_unit.name !== 'Alagoas';
          vm.showEntity = true;
        })
        .catch(() => {
          this.showEntity = false;
          vm.showSwalError('CPF ou CNPJ não localizado')
        })
        .finally(() => {
          vm.$store.dispatch('setLoadingDialog', false);
        })
    },
    async findCityForEntityAddress(entity) {
      this.otherCities = await FederalUnitService.fetchCities(entity.address.federal_unit.id)
      const cityForEntityAddress = find(this.otherCities, { name: entity.address.city.name })
      return cityForEntityAddress;
    },
    async fetchCities(federal_unit) {
      this.otherCities = await FederalUnitService.fetchCities(federal_unit.id)
    },
    updateEntity() {
      this.$store.dispatch('setLoadingDialog', true);
      const entityData = {
        ...this.entity,
        address_attributes: this.entityAddress
      }

      EntityService
        .update(entityData)
        .then(() => {
          this.$swal({
            title: 'Dados alterados com sucesso',
            type: 'success',
            confirmButtonText: 'Ok',
          })
        })
        .catch(({response }) => {
          this.showSwalError('Erro ao alterar dados', response.data.join(', '))
        })
        .finally(() => {
          this.$store.dispatch('setLoadingDialog', false);
        })
    },
    showSwalError(title, message) {
      this.$swal({
        title,
        text: message,
        type: 'error'
      })
    },
  }
}
</script>
